<div
   *ngIf="appointment$ | async; let appointment"
   class="container sam-form-control sam-form-control-full-width"
   (click)="openDetails()"
>
   <div *ngIf="appointmentHasStarted; then isCurrentAppointment; else isFutureAppointment"></div>
   <ng-template #isFutureAppointment>
      <fa-icon
         kendoTooltip
         [title]="'brick.brick_definitions.directory_browser.columns.appointments.title' | translate"
         class="{{ appointment.freeBusyState | toFreeBusyStateClass }} is-future"
         [icon]="futureAppointmentIcon"
         [fixedWidth]="true"
      ></fa-icon>
      <span
         class="sam-margin-left"
         [innerHtml]="
            'brick.brick_definitions.directory_browser.columns.appointments.future_appointment'
               | translate
                  : {
                       comment:
                          (doShowExchangeAppointmentSubjects$ | async)
                             ? appointment.comment
                             : ('brick.brick_definitions.directory_browser.columns.appointments.appointment_subject'
                               | translate),
                       start: appointment.start | toMoment$ | async | amTimeAgo: true
                    }
               | safeHtml
         "
      ></span>
   </ng-template>
   <ng-template #isCurrentAppointment>
      <div *ngIf="appointmentType == typeFromTo">
         <fa-icon
            kendoTooltip
            [title]="'brick.brick_definitions.directory_browser.columns.appointments.title' | translate"
            class="{{ appointment.freeBusyState | toFreeBusyStateClass }}"
            [icon]="currentAppointmentIcon"
            [fixedWidth]="true"
         ></fa-icon>
         <span
            class="sam-margin-left"
            [innerHtml]="
               'brick.brick_definitions.directory_browser.columns.appointments.current_appointment'
                  | translate
                     : {
                          comment:
                             (doShowExchangeAppointmentSubjects$ | async)
                                ? appointment.comment
                                : ('brick.brick_definitions.directory_browser.columns.appointments.appointment_subject'
                                  | translate),
                          end: appointment.end | toMoment$ | async | amDateFormat: 'LT'
                       }
                  | safeHtml
            "
         ></span>
      </div>
      <div *ngIf="appointmentType == typeWholeDay">
         <fa-icon
            class="{{ appointment.freeBusyState | toFreeBusyStateClass }}"
            [icon]="currentAppointmentIcon"
            [fixedWidth]="true"
         ></fa-icon>
         <span
            class="sam-margin-left"
            [innerHtml]="
               'brick.brick_definitions.directory_browser.columns.appointments.current_appointment_day'
                  | translate
                     : {
                          comment:
                             (doShowExchangeAppointmentSubjects$ | async)
                                ? appointment.comment
                                : ('brick.brick_definitions.directory_browser.columns.appointments.appointment_subject'
                                  | translate),
                          end: appointment.end | toMoment$ | async | amDateFormat: 'LT'
                       }
                  | safeHtml
            "
         ></span>
      </div>
      <div *ngIf="appointmentType == typeOpenEnded">
         <fa-icon
            class="{{ appointment.freeBusyState | toFreeBusyStateClass }}"
            [icon]="currentAppointmentIcon"
            [fixedWidth]="true"
         ></fa-icon>
         <span
            class="sam-margin-left"
            [innerHtml]="
               'brick.brick_definitions.directory_browser.columns.appointments.current_appointment_open'
                  | translate
                     : {
                          comment:
                             (doShowExchangeAppointmentSubjects$ | async)
                                ? appointment.comment
                                : ('brick.brick_definitions.directory_browser.columns.appointments.appointment_subject'
                                  | translate),
                          end: appointment.end | toMoment$ | async | amDateFormat: 'LT'
                       }
                  | safeHtml
            "
         ></span>
      </div>
   </ng-template>
</div>
<div *ngIf="!(appointment$ | async)" class="container sam-form-control sam-form-control-full-width">
   <fa-icon
      kendoTooltip
      [title]="'brick.brick_definitions.directory_browser.columns.appointments.title' | translate"
      [icon]="noAppointmentIcon"
      [fixedWidth]="true"
      class="no-data"
   ></fa-icon>
</div>
